import _HslLib from '../_HslLib'
import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { JSONToCSVConvertor, createReportLabel } from '../utils'
export default {

  data: function () {
    return {
      eventList: [],
      startOffset: 0,
      currentPage: 1,
      hasNextPage: false,
      requestData: null,
      perPage: 20,
      pageNumber: 1,
      searchString: '',
      numdaysActive: '',
      searchDeviceID: '',
      dateFrom: '',
      dateTo: '',
      tenantSelection: null,
      statusSelection: null,
      typeSelection: null,
      LbDeviceID: '',
      errorMessage: '',
      fields: {
        leakbotId: {
          label: 'LeakBot ID',
          sortable: false
        },
        eventId: {
          label: 'Event ID',
          sortable: false
        },
        tenant: {
          label: 'Tenant',
          sortable: false
        },
        postCode: {
          label: 'Postcode',
          sortable: false,
          formatter: this.translate
        },
        installTimestamp: {
          label: 'Install timestamp',
          sortable: false
        },
        type: {
          label: 'Type',
          sortable: false,
          formatter: this.translate
        },
        created: {
          label: 'Date Opened',
          sortable: false
        },
        closedDisplayed: {
          label: 'Date closed',
          sortable: false
        },
        numdaysActive: {
          label: 'Number of days active',
          sortable: false
        }
      }
    }
  },
  computed: {
    tenants () {
      return this.$store.state.tenantsList
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchEventListData()
    }
  },
  methods: {
    fetchEventListData (offset, data) {
      data = data || {}
      data.start_record = typeof offset === 'undefined' ? '0' : offset.toString()
      data.fetch_size = this.perPage
      this.requestData = data
      this.$store.dispatch(APIEvent.FETCH_EVENT_LIST, data)
        .then(this.fetchLeakEventResponseHandler)
        .catch(this.handleError)
    },
    fetchLeakEventResponseHandler (res) {
      var records = res.data.list.records
      if (!records) return
      for (var i = 0; i < records.length; i++) {
        var record = records[i]
        if (record.closed === 'null' && record.orig_id === '0') {
          record.closedDisplayed = ''
          record.numdaysActive = Math.round(Math.abs((new Date() - new Date(record.created.replace(' ', 'T') + 'Z')) / (24 * 60 * 60 * 1000)))
        } else if (record.closed === 'null') {
          record.closed = 'N/A'
          record.closedDisplayed = 'N/A'
          record.numdaysActive = 'N/A'
        } else {
          record.closedDisplayed = record.closed
          record.numdaysActive = Math.round(Math.abs((new Date(record.closed.replace(' ', 'T') + 'Z') - new Date(record.created.replace(' ', 'T') + 'Z')) / (24 * 60 * 60 * 1000)))
        }
        if (record.orig_id === '0') {
          record.eventId = record.id
        } else {
          record.eventId = record.orig_id
        }
        if (record.isVIP === '1') {
          record._rowVariant = 'danger'
        }
      }
      if (this.download) {
        this.downloadHandler(records)
        // should we continue to display the data here?
        // return
      }
      this.pageNumber = (this.startOffset / this.perPage) + 1
      this.eventList = records
      this.$store.commit('SET_LEAKLIST', records)
      this.hasNextPage = res.data.LastPage === '0'
    },
    handleError (error) {
      let message = error.message
      switch (error.error) {
        case 209:
          message = 'Device ID is not in the expected format'
          break
        case 305:
          message = 'No matches found'
          break
        case 507:
          message = 'You are not permitted to view the customer profile'
          break
        case 511:
          message = 'Device ID has not been paired with a registered customer account'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    },
    isValidDate (date) {
      if (date === '') {
        return false
      }
      return (_HslLib.isValidDate(date))
    },
    isString (obj) {
      return (Object.prototype.toString.call(obj) === '[object String]')
    },
    search () {
      if (!this.download) {
        this.resetTable()
      }
      let startOffset = this.startOffset
      let searchString = this.searchDeviceID
      let status = this.statusSelection === null ? '' : this.statusSelection
      let type = this.typeSelection === null ? '' : this.typeSelection
      if (Number.isInteger(parseInt(this.typeSelection)) && (parseInt(this.typeSelection) >= 1) && (parseInt(this.typeSelection) <= 21)) {
        type = this.typeSelection
      } else {
        type = ''
      }
      let tenant = this.tenantSelection === null ? '' : this.tenantSelection.id
      var id = ''
      var dateFrom = this.dateFrom !== '' ? this.dateFrom + ' 00:00:00' : ''
      var dateTo = this.dateTo !== '' ? this.dateTo + ' 23:59:59' : ''
      if (dateFrom <= dateTo) {
        if (searchString !== '') {
          this.$store.dispatch(APIEvent.SEARCH, {searchType: 'LeakBotId', searchString})
            .then((results) => {
              id = results[0].lb_id
              this.sanitiseSearchData({startOffset, id, status, type, tenant, dateFrom, dateTo})
            })
            .catch(this.handleError)
        } else {
          this.sanitiseSearchData({startOffset, id, status, type, tenant, dateFrom, dateTo})
        }
      }
      if (dateFrom > dateTo) {
        let message = 'Please enter a valid date before clicking on Apply.'
        EventBus.$emit(StatusBarEvent.ERROR, message)
      }
    },
    getSearchProp (propName) {
      let props = {
        tenant: 'XaTenant_ID',
        id: 'LbDevice_ID',
        status: 'status_id',
        type: 'type_id',
        startOffset: 'start_record',
        dateFrom: 'date_from',
        dateTo: 'date_to'
      }
      let retValue = props[propName]
      return retValue || propName
    },
    sanitiseSearchData (options) {
      options.id = (typeof options.id !== 'undefined') ? options.id : ''
      let data = {'fetch_size': '20'}
      for (var prop in options) {
        if (typeof options[prop] !== 'undefined' && options[prop] !== '') {
          data[this.getSearchProp(prop)] = options[prop].toString()
        }
      }

      data.fetch_size = this.perPage.toString()
      switch (options.status) {
        case 'open':
          data.status_id = '1'
          break
        case 'closed':
          data.status_id = '6'
          break
        default:
          break
      }

      // this.eventList = []
      // this.fetchEventListData(0, data)
      this.eventList = []
      this.fetchEventListData(this.startOffset, data)
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
      } else {
        this.startOffset -= this.perPage
      }
      this.fetchEventListData(this.startOffset, this.requestData)
    },
    translate (value) {
      let translations = {
        'null': '',
        'LeakingToilet': 'Leaking toilet',
        'DrippingTap': 'Dripping tap',
        'Noneofthese': 'None of these',
        'GetHelp': 'Get help',
        'FixMyself': 'Fix myself',
        'Allfixed': 'All fixed',
        'CustomerRepaired': 'Customer repaired',
        'LeakTrue': 'Leak',
        'LeakFalse': 'No Leak',
        'UserLeakRequestNoSignal': 'User Triggered Leak',
        'InitialMonitoring': 'Initial Monitoring',
        'Monitoring': 'Suspected',
        'HighFlow': 'High Usage',
        'NoHighFlow': 'No High Usage',
        'NoSignal': 'No Signal',
        'LowSignal': 'Low Signal',
        'LostSignal': 'Lost Signal',
        'LowBattery': 'Low Battery',
        'NoBattery': 'No Battery',
        'WaitingOnPipe': 'Waiting On Pipe',
        'OnPipe': 'On Pipe',
        'HotPipe': 'On Hot Pipe',
        'AgentLeakRequest': 'Agent Triggered Leak',
        'HardwareProblem': 'Hardware Fault',
        'OffLineDevice': 'Off Line Device'
      }
      return typeof translations[value] === 'undefined'
        ? value
        : translations[value]
    },
    resetTable () {
      this.download = false
      this.perPage = 20
      this.startOffset = 0
      this.hasNextPage = false
      this.pageNumber = 1
      this.errorMessage = ''
    },
    downloadReport () {
      // This will get the first 200 from the leak list
      this.download = true
      this.perPage = 200
      // pass the current start offset so entire records
      // can be manually downloaded
      this.search()
      // this.fetchEventListData(this.startOffset)
      // This just exports current data in view
      // this.downloadHandler(this.eventList)
    },
    downloadHandler (records) {
      var headings = {
        leakbotId: 'DeviceID',
        eventId: 'EventID',
        tenant: 'tenantHeading',
        postCode: 'postCodeHeading',
        installTimestamp: 'installTimestampHeading',
        type: 'eventTypeHeading',
        created: 'eventOpenDate',
        closed: 'eventCloseDate',
        numdaysActive: 'daysActive'
      }
      this.perPage = 20
      this.download = false
      var JsonData = JSON.stringify(records)
      if (JsonData !== '') {
        var title = createReportLabel('Event List')
        JSONToCSVConvertor(JsonData, title, true, headings)
      }
    }
  }
}
